import { useState } from 'react';
import { faqs } from '@/mocks/data';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <section id="faq" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <p className="text-xs md:text-sm font-medium text-primary-500 tracking-widest uppercase mb-2" style={{ fontFamily: "var(--font-label)" }}>
              常见问题
            </p>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              您想了解的问题
            </h2>
            <p className="text-sm text-foreground-500 mt-3">
              快速解答常见疑问，助您无忧畅玩
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 border border-background-200 rounded-xl overflow-hidden transition-all duration-200"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-200 shrink-0 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {openIndex === index && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5 animate-in slide-in-from-top-2">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}